import { useEffect, useState } from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { usePaidCalendarSelectors } from './use-paid-calendar-selectors'

export const usePaidCalendarErrors = () => {
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [isErrorsVisible, setIsErrorsVisible] = useState(false)
  const { selectedDate, selectedTimeSlot } = usePaidCalendarSelectors()
  const { t } = useTypedTranslation()

  const validate = () => {
    let updatedErrors: typeof errors = {}
    if (!selectedDate && !(selectedDate in errors)) {
      updatedErrors = {
        selectedDate: t('entities.calendar.date_field_not_empty'),
      }
    }
    if (typeof selectedTimeSlot !== 'number' && !(selectedTimeSlot in errors)) {
      updatedErrors = {
        ...updatedErrors,
        timeSlot: t('entities.calendar.time_slot_field_not_empty'),
      }
    }
    setErrors(updatedErrors)
  }

  useEffect(() => {
    validate()
  }, [selectedDate, selectedTimeSlot])

  return { errors: Object.values(errors), isErrorsVisible, setIsErrorsVisible }
}
